import React, { FunctionComponent } from 'react';
import { useReactiveVar } from '@apollo/client';
import { selectedCurrencyVar } from '../../../../../../../gqlCommon/graphql/cache';
import FinanceDeposit from './FinanceDeposit';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

const FinanceDepositContainer: FunctionComponent = () => {
  const { selectedCar } = useCustomizeCarContext();
  const selectedCurrency = useReactiveVar(selectedCurrencyVar);
  const deposit = selectedCar?.finance?.simulation?.deposits?.[0].value;

  if (deposit === undefined) {
    return null;
  }

  return <FinanceDeposit deposit={deposit} currency={selectedCurrency} />;
};

export default FinanceDepositContainer;
